<template>
    <div>
        <div class="options-fields-container">
            <button @click="checkIsAllProductsOnAllWarehouses">Проверить, всё ли на всех складах</button>
            <v-select v-model="selectedWarehouse" :items="warehouses" label="Склад" @change="dataChanged"></v-select>
            <v-text-field
                v-model="calculationDays"
                label="За сколько дней просмотреть аналитику? (Х)"
                title="За сколько дней просмотреть аналитику?"
                type="number"
                @change="dataChanged"
            />
            <v-text-field
                v-model="predictionDaysCount"
                label="На сколько дней сделать прогноз продаж? (N)"
                title="На сколько дней сделать прогноз продаж"
                type="number"
                @change="dataChanged"
            />
            <v-text-field
                v-model="needDaysToPrepareShipment"
                label="Сколько дней проходит с момента формирования заказа на закуп до поступления товара на склад? (Y)"
                title="Сколько дней проходит с момента формирования заказа на закуп до поступления товара на склад? (Y)"
                type="number"
                @change="dataChanged"
            />
        </div>

        <v-data-table
            :headers="headers"
            :items="products"
            :items-per-page="-1"
            :loading="loading"
            class="elevation-1"
            fixed-header
            height="100vh"
        >
            <template #item="{ item, index, headers }">
                        <tr>
                            <td v-for="n in headers">
                                {{ n.text === '№' ? index + 1 : item[n.value] }}
                                <v-menu v-if="n.value === 'seeCharts'"  offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <a v-on="on">Смотреть графики</a>
                                    </template>
                                    <v-list height="250" width="800">
                                        <BarChart v-if="showBarChart" :chart-data="getItemChartData(item.article)" :height="100"
                                                  :options="options"></BarChart>
                                    </v-list>
                                  <v-list height="250" width="800">
                                    <BarChart v-if="showBarChart" :chart-data="getItemPriceData(item.article)" :height="100"
                                              :options="options"></BarChart>
                                  </v-list>
                                    <v-list height="250" width="800">
                                        <BarChart v-if="showBarChart" :chart-data="getItemStocksData(item.article, item.id)" :height="100"
                                                  :options="options"></BarChart>
                                        <span style="padding-left: 5px"> Знак 🚫 говорит о том, что нет данных об остатках за этот день (аналитика не работала)</span>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
        </v-data-table>
    </div>
</template>


<script>
    import OzonService from '../services/ozon.service';
    // import json from '/root/tovarka/data.json'
    // import json from '/Users/damirilyasov/Desktop/Work/tovarka/data.json'
    // import pricesLocal from '/Users/damirilyasov/Desktop/папка/Work/tovarka/prices.json'
    // import alreadyOrderedProductsFile from '/Users/damirilyasov/Desktop/папка/Work/tovarka/alreadyOredered.json'
    import BarChart from '../components/BarChart';
    import moment from 'moment';
    import { $http } from '../services/http';

    const WAREHOUSE_NOT_SELECTED = 'Данные за все склады';

    export default {
        name: 'Home',
        components: {BarChart},
        data: () => ({
            options: {
                responsive: true
            },
            loading: false,
            // используется для перерендера чарта (костыль)
            showBarChart: true,
            dataFile: null,
            pricesFile: null,
            alreadyOrderedProducts: [],
            // oldMarketPricesFile: null,
            calculationDays: 30,
            predictionDaysCount: 30,
            needDaysToPrepareShipment: 10,
            products: [],
            warehousesData: [],
            allWarehousesMergedData: {items: [], warehouseName: WAREHOUSE_NOT_SELECTED},
            productInfoMap: new Map(),
            selectedWarehouse: WAREHOUSE_NOT_SELECTED,
            headers: [
                {text: '№'},
                {text: 'Артикул', value: 'article', width: '50px'},
                {text: 'Название', value: 'name', width: '100px'},
                {text: 'Кол-во продаж за последние X дней', value: 'totalSales'},
                {text: 'Себес', value: 'sebes'},
                {text: 'Цена продажи', value: 'marketPrice'},
                // {text: 'Нужно повысить цену до', value: 'neededPrice'},
                // {text: 'Цена повысилась на', value: 'priceChangedTo'},
                // {text: 'Шаг повышения', value: 'priceChangeStep'},
                {text: 'ROI без логистики', value: 'roi'},
                // {text: 'Новый ROI', value: 'newRoi'},
                {text: 'Чистая прибыль за 1 продажу (без логистики)', value: 'netProfitPerOneSale'},
                // {text: 'Новая чистая прибыль за 1 продажу (без логистики)', value: 'newNetProfitPerOneSale'},
                {text: 'Прогнозируемая чистая прибыль за N дней (без логистики)', value: 'netProfitPredictionForPeriod'},
                {text: 'Темп продаж (шт/день)', value: 'salesRate'},
                // {text: 'Нужен закуп?', value: 'needToCreateShipment'},
                {text: 'Прогноз продаж на N дней', value: 'salesPredictionForXDays'},
                {text: 'Остаток на складе озон', value: 'countLeft'},
                {text: 'Уже заказано', value: 'alreadyOrderedCount'},
                {text: 'Нужно докупить', value: 'needToBuyCount'},
                {text: 'Графики продаж и остатков', value: 'seeCharts'}
            ],
            warehouses: [WAREHOUSE_NOT_SELECTED],
            testProduct: null,
            postingsByDays: [],
        }),

        async mounted() {
            this.loading = true;
            const envWarehouses = process.env.VUE_APP_WAREHOUSES.split(', ');
            this.warehouses.push(...envWarehouses)
            this.pricesFile = (await $http.get(process.env.VUE_APP_PRICES_FILE_ADDRESS)).data;
            // this.pricesFile = pricesLocal;
            // this.alreadyOrderedProducts = alreadyOrderedProductsFile;
            this.alreadyOrderedProducts = (await $http.get(process.env.VUE_APP_ALREADY_ORDERED_FILE_ADDRESS)).data;
            // this.oldMarketPricesFile = (await $http.get(process.env.VUE_APP_OLD_MARKET_PRICE)).data;
            this.dataFile = (await $http.get(process.env.VUE_APP_STOCKS_FILE_ADDRESS)).data;
            // this.dataFile = json;
            await this.prepareData();
            await this.prepareRoiData();
            this.loading = false;

            // await this.checkIsAllProductsOnAllWarehouses();
        },

        methods: {
            async checkIsAllProductsOnAllWarehouses() {
              console.log("Начинаем проверку под кодовым названием 'НЕ ТЕРЯЙ БАБЛО, ГРУЗИ НА ВСЕ СКЛАДЫ, СУКА'");

              const warehouseProductsMap = new Map;

              let tableObject = {};

              for (let i = 0; i < this.warehouses.length; i++) {
                if (this.warehouses[i] !== WAREHOUSE_NOT_SELECTED && this.warehouses[i] !== "Новосибирск_РФЦ_НОВЫЙ") {
                  tableObject[this.warehouses[i]] = 0;
                  console.log('Проверяем ' + this.warehouses[i])
                  this.selectedWarehouse = this.warehouses[i];
                  await this.dataChanged();
                  warehouseProductsMap.set(this.warehouses[i], JSON.parse(JSON.stringify(this.products.filter(p => p.countLeft > 0 || p.alreadyOrderedCount > 0))))
                }
              }

              // let biggestWarehouse = '';
              console.log('Результаты проверки:')

              let table = {};

              console.log('Кол-во товаров в наличии на складах')
              warehouseProductsMap.forEach((value, key) => {
                value.forEach(product => {
                  if (!table[product.article]) {
                    table[product.article] = JSON.parse(JSON.stringify(tableObject));
                  }
                  table[product.article][key] = Number(product.countLeft) + Number(product.alreadyOrderedCount);
                })
                console.log(key + ': ' + value.length)
              })

              let filteredTable = {};
              for (const [key, value] of Object.entries(table)) {
                let isPresentOnAnyWarehouse = false;
                let isPresentOnWarehouseCount = 0;
                let warehousesCount = 0;
                for (const [key1, value1] of Object.entries(value)) {
                  warehousesCount++;
                  if (value1 > 0) {
                    isPresentOnWarehouseCount++;
                    isPresentOnAnyWarehouse = true;
                    break;
                  }
                }
                if (isPresentOnWarehouseCount < warehousesCount) {
                  filteredTable[key] = value;
                }
              }

              console.log('Всего')
              console.table(filteredTable);
            },

            async prepareRoiData() {
                this.loading = true;
                const pricesData = (await OzonService.loadPrices()).data.result.items;
                this.products.forEach(product => {
                    const productPriceData = pricesData.find(priceData => priceData.product_id === product.id);
                    const premiumPrice = productPriceData.price.premium_price;
                    if (productPriceData.price.price <= productPriceData.price.min_price && this.selectedWarehouse === WAREHOUSE_NOT_SELECTED) {
                        console.log("Проверь цену на" + product.article)
                    }
                    let currentMinimalPrice = productPriceData.price.min_price;
                    if (premiumPrice && currentMinimalPrice > premiumPrice) {
                        currentMinimalPrice = premiumPrice;
                    }
                    const allCommissions = productPriceData.commissions.fbo_fulfillment_amount +
                        productPriceData.commissions.fbo_direct_flow_trans_max_amount +
                        productPriceData.commissions.fbo_deliv_to_customer_amount +
                        ((currentMinimalPrice / 100) * productPriceData.commissions.sales_percent);
                    const costPrice = this.pricesFile.find(jsonProduct => jsonProduct.article === product.article);
                    // let oldMarketPrice = (this.oldMarketPricesFile.find(jsonProduct => jsonProduct.article === product.article));
                    // if (oldMarketPrice) {
                    //     oldMarketPrice = oldMarketPrice.oldPrice;
                    // }
                    if (!costPrice || !costPrice.newPrice) {
                        // console.error('Не задана себестоимость у ' + product.article);
                    } else {
                        // вместо актуальных данных из рекламы, береём 10% по дефолту
                        const marketingCost = (costPrice.newPrice / 100) * 10;
                        let roi = ((((currentMinimalPrice - allCommissions - marketingCost) / 100) * 94) / costPrice.newPrice) - 1;
                        // рои по новым ценам
                        let newRoi = ((((currentMinimalPrice - allCommissions - marketingCost) / 100) * 94) / costPrice.newPrice) - 1;
                        // product.costPrice = Math.round(costPrice.price * 100) / 100;
                        product.oldSebes = costPrice.price;
                        product.sebes = costPrice.newPrice;
                        // product.oldMarketPrice = oldMarketPrice;
                        product.marketPrice = Math.round(currentMinimalPrice * 100) / 100;
                        product.roi = Math.round(roi * 100) / 100;
                        product.newRoi = Math.round(newRoi * 100) / 100;
                        // product.priceChangedTo = Math.round((costPrice.newPrice - costPrice.price) * 100) / 100;

                        // считаем чистую прибыль
                        product.netProfitPerOneSale = ((currentMinimalPrice - allCommissions - marketingCost) / 100) * 94 - costPrice.newPrice;
                        // прогнозируем чистую прибыль за период
                        product.netProfitPredictionForPeriod = product.netProfitPerOneSale * product.salesPredictionForXDays;

                        product.netProfitPerOneSale = Math.round(product.netProfitPerOneSale * 100) / 100
                        product.netProfitPredictionForPeriod = Math.round(product.netProfitPredictionForPeriod * 100) / 100

                        if (costPrice.price && costPrice.newPrice) {
                            product.newNetProfitPerOneSale = ((currentMinimalPrice - allCommissions - marketingCost) / 100) * 94 - costPrice.newPrice;
                            product.newNetProfitPerOneSale = Math.round(product.newNetProfitPerOneSale * 100) / 100

                            // const neededPrice = Number(oldMarketPrice) + ((costPrice.newPrice - costPrice.price) / 100 * 110)
                            // product.neededPrice = Math.round(neededPrice * 100) / 100
                            // product.priceChangeStep = (product.neededPrice - oldMarketPrice) / 5;
                            // product.priceChangeStep = Math.round(product.priceChangeStep * 100) / 100
                        }
                    }
                })
                this.products = JSON.parse(JSON.stringify(this.products))
                this.loading = false;
            },

            getItemPriceData(article) {
              const chartData = {
                labels: [],
                datasets: [
                  {
                    label: 'Цена продажи',
                    backgroundColor: 'red',
                    data: [],
                  }
                ]
              }
              const productSalesDayData = this.findProductPostingsByDays(article);
              if (!productSalesDayData) {
                return chartData;
              }
              productSalesDayData.forEach(dayData => {
                const date = dayData.date.format('YYYY-MM-DD')
                chartData.labels.push(date);
                const salesToday = dayData.prices[0];
                chartData.datasets[0].data.push(salesToday);
              })
              return chartData;
            },

            getItemChartData(article) {
                const chartData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Продаж за день',
                            backgroundColor: '#46e33c',
                            data: [],
                        }
                    ]
                }
                const productSalesDayData = this.findProductPostingsByDays(article);
                if (!productSalesDayData) {
                    return chartData;
                }
                productSalesDayData.forEach(dayData => {
                    const date = dayData.date.format('YYYY-MM-DD')
                    chartData.labels.push(date);
                    const salesToday = dayData.postingsCount;
                    chartData.datasets[0].data.push(salesToday);
                })
                return chartData;
            },

            getItemStocksData(article, id) {
                const chartData = {
                    labels: [],
                    datasets: [
                        {
                            label: 'Остаток на складе',
                            backgroundColor: 'gray',
                            data: [],
                        }
                    ]
                }
                const productSalesDayData = this.findProductPostingsByDays(article);
                const productStocksDayData = this.findProductDayData(id)
                if (!productSalesDayData) {
                    return chartData;
                }
                productSalesDayData.forEach(dayData => {
                    const date = dayData.date.format('YYYY-M-D')
                    const stockDayData = productStocksDayData.find(data => data.date === date);
                    chartData.datasets[0].data.push(stockDayData ? stockDayData.countLeft : 0);
                    if (!stockDayData) {
                        // console.log(productStocksDayData)
                        // console.log(date)
                        // debugger

                        chartData.labels.push('🚫' +date);
                    } else {
                        chartData.labels.push(date);
                    }
                })
                return chartData;
            },

            async prepareData() {
                const responseItems = (await OzonService.loadAllProductsIds()).data.result.items;
                const productsIds = responseItems.map((item => item.product_id))

                this.products = (await OzonService.loadAllProductsInfo(productsIds)).data.result.items.map(item => {
                    return {
                        name: item.name,
                        id: item.id,
                        dayData: [],
                        article: item.offer_id,
                        marketing_price: item.marketing_price
                    }
                })

                this.warehousesData = [];
                this.warehouses.forEach(warehouseName => {
                    if (warehouseName !== WAREHOUSE_NOT_SELECTED) {
                        this.warehousesData.push({
                            warehouseName,
                            items: JSON.parse(JSON.stringify(this.products))
                        })
                    }
                })


                this.dataFile.forEach(dayData => {
                    const date = dayData.date;
                    dayData.data.forEach(warehouseDayData => {
                        const neededWarehouse = this.warehousesData.find(w => w.warehouseName === warehouseDayData.warehouseName)
                        if (neededWarehouse) {
                          warehouseDayData.itemsData.forEach(itemData => {
                            const item = neededWarehouse.items.find(i => i.id === itemData.itemId);
                            if (item) {
                              let salesToday = 0;
                              if (item.dayData.length) {
                                const previousDayData = item.dayData[item.dayData.length - 1];
                                salesToday = previousDayData.countLeft - itemData.countLeft;
                                // Был сбой, данные за этот день неверны
                                if (date === '2021-10-19') {
                                  salesToday = 0
                                }
                              }
                              item.dayData.push({date, countLeft: itemData.countLeft, salesToday})
                            }
                          })
                        }

                    })
                })


                this.warehousesData.forEach(warehouseData => {
                    warehouseData.items.forEach(item => {
                        const alreadyAddedItem = this.allWarehousesMergedData.items.find(alreadyAddedItem => alreadyAddedItem.id === item.id);
                        if (!alreadyAddedItem) {
                            this.allWarehousesMergedData.items.push(JSON.parse(JSON.stringify(item)));
                        } else {
                            item.dayData.forEach(dayDataItem => {
                                const alreadyAddedDayData = alreadyAddedItem.dayData
                                    .find(alreadyAddedDayData => alreadyAddedDayData.date === dayDataItem.date);
                                if (!alreadyAddedDayData) {
                                    alreadyAddedItem.dayData.push(JSON.parse(JSON.stringify(dayDataItem)))
                                } else {
                                    alreadyAddedDayData.countLeft += dayDataItem.countLeft;
                                }
                            })
                        }
                    })
                })
                await this.dataChanged();
            },

            findProductDayData(productId) {
                if (this.selectedWarehouse !== WAREHOUSE_NOT_SELECTED) {
                    return this.warehousesData.find(warehouse => warehouse.warehouseName === this.selectedWarehouse)
                        .items.find(item => item.id === productId).dayData
                        .slice(this.calculationDays * -1);
                } else {
                  let item = this.allWarehousesMergedData.items.find(item => item.id === productId);
                  if (item) {
                    return item.dayData.slice(this.calculationDays * -1);
                  } else {
                    return [];
                  }
                }
            },

            findProductPostingsByDays(article) {
                return this.postingsByDays.map(posting => {
                    const productPostings = posting.productsPostings.find(p => p.article === article);
                    return {
                        date: posting.date,
                        postingsCount: productPostings ? productPostings.postingsCount : 0,
                        prices: productPostings ? productPostings.prices : []
                    }
                })
            },

            async dataChanged() {
                this.loading = true;

                const warehouseData = this.selectedWarehouse !== WAREHOUSE_NOT_SELECTED ?
                    this.warehousesData.find(warehouse => warehouse.warehouseName === this.selectedWarehouse) :
                    this.allWarehousesMergedData;

                const allPostings = (await OzonService.loadAllFboPostings(this.calculationDays)).sort((a, b) => {
                    return moment(a.created_at) - moment(b.created_at);
                });

                let postingsForNeededWarehouse = allPostings;
                if (this.selectedWarehouse !== WAREHOUSE_NOT_SELECTED) {
                    postingsForNeededWarehouse = allPostings.filter(posting =>
                        posting.analytics_data && posting.analytics_data.warehouse_name.toLowerCase().replaceAll('-', '_')
                        === this.selectedWarehouse.toLowerCase().replaceAll('-', '_')
                          // добавил replace, потому что в списке заказов пишут САНКТ-ПЕТЕРБУРГ_РФЦ, а склад называют САНКТ_ПЕТЕРБУРГ_РФЦ
                    )
                }

                const postingsByDays = [];
                for (let i = this.calculationDays - 1; i >= 0; i--) {
                    const todayData = {date: moment().subtract(i, 'day').startOf('day'), productsPostings: []}
                    for (let j = 0; j < postingsForNeededWarehouse.length; j++) {
                        const posting = postingsForNeededWarehouse[j];
                        // баг озона. Он возвращает отправления, которые были до указанного периода (днём ранее)
                        if (moment(posting.created_at).isBefore(todayData.date)) {
                            continue;
                        }
                        if (moment(posting.created_at).isSame(todayData.date, 'day')) {
                            if (posting.status !== 'cancelled') {
                                posting.products.forEach(product => {
                                    const existingProductInPostingsList = todayData.productsPostings
                                        .find(productsPosting => product.offer_id === productsPosting.article);

                                    if (existingProductInPostingsList) {
                                        existingProductInPostingsList.postingsCount += product.quantity;
                                        const alreadyAddedPrice = existingProductInPostingsList.prices.find(p => p === product.price);
                                        if (!alreadyAddedPrice) {
                                          existingProductInPostingsList.prices.push(product.price);
                                        }
                                    } else {
                                        todayData.productsPostings.push({
                                            article: product.offer_id,
                                            postingsCount: product.quantity,
                                            id: product.sku,
                                            prices: [product.price]
                                        })
                                    }
                                })
                            }
                        } else {
                            postingsForNeededWarehouse = postingsForNeededWarehouse.slice(j);
                            break
                        }
                    }
                    postingsByDays.push(todayData)
                }

                this.postingsByDays = postingsByDays;

                // const postingsForNeededWarehouse = allPostings.filter(posting => )

                this.products.forEach(product => {
                    // считаем остаток на складе
                    const item = warehouseData.items.find(i => i.id === product.id);
                    const lastDayItemData = item.dayData[item.dayData.length - 1];
                    product.countLeft = lastDayItemData ? lastDayItemData.countLeft : 0;
                })

                // считаем общее кол-во продаж
                this.products.forEach(product => {
                    const productDayData = this.findProductDayData(product.id);
                    const postingsDaysData = this.findProductPostingsByDays(product.article);

                    let totalSales = 0;

                    let daysWhenProductWasOnStock = 0;

                    postingsDaysData.forEach(postingDayData => {
                        // const date = dayData.date.format('YYYY-MM-D')
                        const dayData = productDayData.find(data => data.date === postingDayData.date.format('YYYY-M-D'));
                        // если он был на складе или были продажи в этот день, то день учитывается в темпе продаж
                        if (postingDayData.postingsCount || (dayData && dayData.countLeft)) {
                            daysWhenProductWasOnStock++;
                        }
                        totalSales += postingDayData.postingsCount;
                    })

                    product.totalSales = Math.round((totalSales * 100) / 100);

                    // считаем темп продаж
                    product.salesRate = Math.round(totalSales / daysWhenProductWasOnStock * 100) / 100

                    // считаем прогноз продаж на {predictionDaysCount} дней
                    product.salesPredictionForXDays = Math.round((product.salesRate * this.predictionDaysCount * 100) / 100);

                    const orderedProduct = this.alreadyOrderedProducts.find(orderedProduct => orderedProduct.article === product.article)
                    if (orderedProduct) {
                      product.alreadyOrderedCount = orderedProduct[this.selectedWarehouse] || 0;
                    } else {
                      product.alreadyOrderedCount = 0;
                    }

                    // считаем, сколько нужно докупить чтобы хватило на указаный период
                    const needToBuyCount = product.salesPredictionForXDays - product.countLeft;
                    product.needToBuyCount = needToBuyCount - product.alreadyOrderedCount;

                    // считаем, пора ли уже закупать
                    product.needToCreateShipment = product.countLeft <= product.salesPredictionForXDays;
                })


                this.products = JSON.parse(JSON.stringify(this.products))
                this.showBarChart = false;

                setTimeout(() => {
                    this.showBarChart = true;
                }, 500)

                await this.prepareRoiData();

                this.loading = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .options-fields-container {
        padding-left: 20px;
        padding-right: 20px;
    }

</style>
